export default {
  SETDATA(state, res) {
    state.data = res.data || {};
  },
  SETOPTIONS(state, res) {
    Object.keys(res).forEach(item => (state[item] = res[item]))
  },
  setSearchData_M(state, res) {
    Object.keys(res).forEach(item => (state.searchData[item] = res[item]))
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Operation/mutations.js